import React, { useState } from "react";
import { setRecoilExternalState } from "RecoilExternalState";
import { defaultWarningProps, warningProps } from "recoil/atom";
import { useRecoilState } from "recoil";
import BasicDialog from "components/Dialog/BasicDialog";
import { Typography } from "@mui/material";
import { ButtonContained, ButtonOutlined } from "components/button/CommonButton";
import FizenInput from "components/form/FizenInput";

export const warning = (
  title,
  onOK,
  options = { showInputReason: false, buttonConfirmProps: { title: "Confirm" }, content: "" },
  onClose,
) => {
  setRecoilExternalState(warningProps, {
    title: title,
    visible: true,
    onOK,
    onClose,
    options,
  });
};

function WarningDialog() {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [prop, setProp] = useRecoilState(warningProps);
  const {
    visible,
    onOK,
    title,
    options: { showInputReason, buttonConfirmProps, content },
  } = prop;

  const handleCancel = () => {
    setProp(defaultWarningProps);
    setReason("");
  };

  const handleChangeReason = (e) => {
    setReason(e.target.value);
  };

  const handleConfirm = async () => {
    if (onOK) {
      setLoading(true);
      await onOK(reason, { showInputReason });
      setLoading(false);
    }
    handleCancel();
  };

  return (
    <BasicDialog open={visible} onClose={handleCancel} sx={{ "& .MuiPaper-root": { width: 400 } }}>
      <Typography component="p" align="center" variant="big" sx={{ color: "text.black" }}>
        {title}
      </Typography>
      {showInputReason && (
        <FizenInput
          multiline
          rows={3}
          label="Reason (optional)"
          value={reason}
          onChange={handleChangeReason}
        />
      )}
      {content && <div>{content}</div>}
      <div className="flex flex-col items-center gap-2 mt-5 w-full">
        <ButtonContained onClick={handleConfirm} loading={loading} fullWidth>
          {buttonConfirmProps?.title ?? "Confirm"}
        </ButtonContained>
        <ButtonOutlined
          sx={{ borderColor: "transparent", display: loading ? "none" : "" }}
          onClick={handleCancel}
          fullWidth
        >
          Cancel
        </ButtonOutlined>
      </div>
    </BasicDialog>
  );
}

export default WarningDialog;
